import { appSettings } from "../AppSettings";
import { HttpError } from "./ApiClient";


interface INedEvent {
    ntcId: number;
    ntcSystemUrl: string;
    eventTitle: string;
}

interface IUsageStats {
    deviceId: string;
    event: INedEvent;
}

class LmApiClient {

    async sendUsageStatsAsync(stats: IUsageStats) {

        //stats.deviceId = "4eb9333f279b3cb7";

        const response = await fetch(appSettings.lmApiUrl + "device/usage-stats", {
            method: "POST",
            body: JSON.stringify(stats),
            headers: {
                "Content-Type":"application/json"
            }
        });

        if (!response.ok)
            throw new HttpError(response);

        const text = await response.text();

        return JSON.parse(text) as boolean;
    }

    async getDeviceLicenceSettingsAsync(deviceId: string) {

        const response = await fetch(appSettings.lmApiUrl + `device/${deviceId}/licence-settings`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (!response.ok)
            throw new HttpError(response);

        const text = await response.text();

        return JSON.parse(text) as Record<string, unknown>;
    }
}


const lmApiClient = new LmApiClient();

export default lmApiClient;